import { render } from "./EditRiderInfo.vue?vue&type=template&id=61d1af3a"
import script from "./EditRiderInfo.vue?vue&type=script&lang=js"
export * from "./EditRiderInfo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__